// @ts-check
import SimpleTable, { RowSelection } from 'components/Common/SimpleTable/SimpleTable';
import React, { useCallback } from 'react';

/**
 * Data type for the example data
 * @typedef {object} ExampleDataType
 * @prop {string} id
 * @prop {string} name
 * @prop {number} age
 * @prop {string} address
 * @prop {string} [extra]
 */

/**
 * @type {ExampleDataType[]}
 */
const data = [...Array(20)].map((unused, index) => ({
  id: index.toString(),
  name: 'name' + index,
  age: 32 + Math.random() * 10,
  address: 'address' + index
}));

/**
 * @type {import('components/Common/SimpleTable/SimpleTable').ColumnType<ExampleDataType>[]}
 */
const columns = [
  {
    label: 'Id',
    path: 'id',
    isSortable: true
  },
  {
    label: 'Name',
    path: 'name',
    isSortable: true,
    searchItem: true
  },
  {
    label: 'Age',
    path: 'age',
    isSortable: true
  },
  {
    label: 'Address',
    path: 'address',
    isSortable: true
  },
  {
    label: 'Extra data',
    path: 'extra',
    isSortable: true
  }
];

/**
 * @type {import('components/Common/SimpleTable/SimpleTable').SortByType<ExampleDataType>}
 */
const DefaultSortBy = {
  path: 'name',
  direction: 'desc'
};

const SimpleTableCheckboxExample = () => {

  // eslint-disable-next-line no-console
  const onClickRow = useCallback(row => console.log('row', row), []);
  const [selected, setSelected] = React.useState([]);
  return (
    <SimpleTable
      columns={columns}
      data={data}
      sortBy={DefaultSortBy}
      rowSelection={RowSelection.MULTI_CHECKBOX}
      selectedRows={selected}
      onSelectedRows={setSelected}
      onRowClick={onClickRow}
      usePaging
      pageSize={5}
    />
  );
};
export default SimpleTableCheckboxExample;
